import React, { FC } from 'react';
import Slider from '../../common/components/Slider';
import { useImagery } from '../hooks';

interface ImageryProps {
  label: string;
}

const Imagery: FC<ImageryProps> = ({ label }) => {
  const { isVisible, isUpdating, opacity, actions } = useImagery(label)
  const { updateOpacity, toggle } = actions

  if (isVisible) {
    return (
      <div className="row on">
        <div className="cell label" onClick={toggle}>{label}</div>
        <div className="cell content">
          <Slider value={opacity} onChange={updateOpacity} updating={isUpdating} />
        </div>
      </div>
    )
  } else {
    return (
      <div className="row disabled" onClick={toggle}>
        <div className="cell label">{label}</div>
        <div className="cell content"></div>
      </div>
    )
  }
}

export default Imagery